import gql from 'graphql-tag';
import { firstValueFrom } from 'rxjs';
import { addActionBarItem, PageLocationId } from '@bb-vendure/admin-ui/core';


export default [
    // addActionBarItem({
    //     id: 'create-in-suyoda',
    //     label: 'Create In Suyoda',
    //     locationId: 'product-list',
    //     onClick: async (event, context) => {
    //         try {
    //             const orderId = context.
    //             context.dataService.mutate(BatchCreateInSuyodaDocument, { ids: [orderId] });
    //             // context.dataService.mutate
    //             // await firstValueFrom(context.dataService.mutate(mutation, { orderId }));
    //         } catch (error: any) {
    //             context.notificationService.error('Error executing mutation: ' + error.message);
    //         }
    //     },
    // }),
];
